import { render, staticRenderFns } from "./BackOffice.vue?vue&type=template&id=22fdc08a&"
import script from "./BackOffice.vue?vue&type=script&lang=js&"
export * from "./BackOffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22fdc08a')) {
      api.createRecord('22fdc08a', component.options)
    } else {
      api.reload('22fdc08a', component.options)
    }
    module.hot.accept("./BackOffice.vue?vue&type=template&id=22fdc08a&", function () {
      api.rerender('22fdc08a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/statistics/BackOffice.vue"
export default component.exports